import React, { useId } from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const FaNeedMoreDataIconGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('#B8BABC', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M13 11H11V14H8V16H11V19H13V16H16V14H13V11ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
        fill={fillColor}
      />
    </g>
  );
};

export const FaNeedMoreDataIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <FaNeedMoreDataIconGroup {...props} />
    </svg>
  );
};
